import type { Team } from '@halvard/rules';

/** Terrain colours by height 0 → 4: lake, meadow, moss, rock, snow. */
export const TERRAIN_COLORS = ['#4E7F84', '#9DB36B', '#6E8C4A', '#8F7A63', '#D9D4C7'] as const;

/**
 * Terrain colours for the experimental tall mountains (heights 0 → 6): the five standard colours
 * plus forest between moss and rock, and scree between rock and snow.
 */
export const TALL_TERRAIN_COLORS = [
  '#4E7F84',
  '#9DB36B',
  '#6E8C4A',
  '#4F6B3A',
  '#8F7A63',
  '#B3A796',
  '#D9D4C7',
] as const;

/** Colour of a square at height h. Boards with any square above 4 use the tall palette. */
export function terrainColor(h: number, tall: boolean): string {
  const palette = tall ? TALL_TERRAIN_COLORS : TERRAIN_COLORS;
  return palette[Math.min(Math.max(h, 0), palette.length - 1)] ?? palette[0];
}

export const TEAM_COLORS: Readonly<Record<Team, { body: string; ring: string }>> = {
  I: { body: '#EFE8D8', ring: '#E8742E' },
  B: { body: '#30343B', ring: '#4FB3C4' },
};

export const COLORS = {
  plinth: '#16201B',
  fog: '#1A2420',
  summit: '#E8742E',
  pinned: '#F2C14E',
  moveHint: '#F1EDE2',
  captureHint: '#E8742E',
  pinHint: '#F2C14E',
  buildHint: '#3FD0E8',
  cursor: '#FFFFFF',
  selected: '#F1EDE2',
  lastMove: '#E8742E',
} as const;
